/**
 * Landing Feature - Constants
 *
 * NOTE: Uses global AppImages and siteConfig for centralized configuration.
 * Feature-specific constants that don't need centralization are defined here.
 */

import { AppImages, ROUTES } from "@/constants";
import { siteConfig } from "@/config/site";
import type { FeatureItem } from "../domain/entities";

/**
 * Feature items for the features section
 * Uses global AppImages for image paths
 */
export const FEATURE_ITEMS: FeatureItem[] = [
  {
    id: "partnership",
    title: "landing.features.partnership.title",
    description: "landing.features.partnership.description",
    imageSrc: AppImages.kAboutUs1,
    imageAlt: "landing.features.partnership.imageAlt",
    imagePosition: "left",
  },
  {
    id: "tailored",
    title: "landing.features.tailored.title",
    description: "landing.features.tailored.description",
    imageSrc: AppImages.kAboutUs2,
    imageAlt: "landing.features.tailored.imageAlt",
    imagePosition: "right",
  },
  {
    id: "focus",
    title: "landing.features.focus.title",
    description: "landing.features.focus.description",
    imageSrc: AppImages.kAboutUs3,
    imageAlt: "landing.features.focus.imageAlt",
    imagePosition: "left",
  },
];

/**
 * Get contact information from siteConfig
 * This is a getter to ensure we always get fresh values
 */
export const getContactInfo = () => siteConfig.contact;

/**
 * Navigation links
 */
export const NAV_LINKS = [
  { id: "home", href: "#top", labelKey: "landing.nav.home" },
  { id: "about", href: "#about_us", labelKey: "landing.nav.aboutUs" },
  { id: "contact", href: "#contact", labelKey: "landing.nav.contact" },
] as const;

/**
 * Footer links
 */
export const FOOTER_SECTIONS = {
  agarea: [
    { labelKey: "landing.nav.home", href: "#top" },
    { labelKey: "landing.contact.title", href: "#contact" },
  ],
  information: [
    { labelKey: "legal.termsOfService", action: "terms" },
    { labelKey: "legal.privacyPolicy", action: "privacy" },
    { labelKey: "landing.nav.aboutUs", href: "#about_us" },
  ],
  support: [{ labelKey: "landing.footer.faq", href: "#" }],
} as const;

/**
 * Landing page images - references to global AppImages
 */
export const LANDING_IMAGES = {
  logo: AppImages.kSvgLogo,
  backgroundTractor: AppImages.kBackgroundTractor,
  aboutUs1: AppImages.kAboutUs1,
  aboutUs2: AppImages.kAboutUs2,
  aboutUs3: AppImages.kAboutUs3,
} as const;

/**
 * Landing page routes - references to global ROUTES
 */
export const LANDING_ROUTES = {
  dashboard: ROUTES.DASHBOARD,
} as const;
